import { render, staticRenderFns } from "./Consultant.vue?vue&type=template&id=4f670792&"
import script from "./Consultant.vue?vue&type=script&lang=js&"
export * from "./Consultant.vue?vue&type=script&lang=js&"
import style0 from "./Consultant.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Consultant.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports